import React from 'react';
import '../styles/style.scss'

const Footer = ({ siteInfo }) => (
    <footer>
        <div className='wrapper'>
            Copyright &copy; 2022{!!siteInfo.legal && (" " + siteInfo.legal)}. All Rights Reserved.
        </div>
    </footer> 
)

export default Footer
